import PropTypes from "prop-types"
import { intComma } from "humanize-plus"

import "./service_engagements.scss"

const ServiceEngagements = ({
  engagementsTotal,
  appletRunsTotal,
  appletEnablesTotal,
  appletRatingsTotal,
  ctaClicksTotal,
}) => (
  <div className="service-engagements">
    <div styleName="engagements-header" className="stat-box">
      <h3>Total service engagements</h3>
      <p className="stat">{intComma(engagementsTotal)}</p>
    </div>
    <div styleName="engagements-list" className="stat-box">
      <table>
        <tbody>
          <tr>
            <td>Applet runs</td>
            <td>{intComma(appletRunsTotal)}</td>
          </tr>
          <tr>
            <td>Applet enabled</td>
            <td>{intComma(appletEnablesTotal)}</td>
          </tr>
          <tr>
            <td>Applet ratings</td>
            <td>{intComma(appletRatingsTotal)}</td>
          </tr>
          <tr>
            <td>Call-to-action clicks</td>
            <td>{intComma(ctaClicksTotal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)

ServiceEngagements.propTypes = {
  engagementsTotal: PropTypes.number.isRequired,
  appletRunsTotal: PropTypes.number.isRequired,
  appletEnablesTotal: PropTypes.number.isRequired,
  appletRatingsTotal: PropTypes.number.isRequired,
  ctaClicksTotal: PropTypes.number.isRequired,
}

export default ServiceEngagements
